// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-page {
  min-height: 100%;
  padding: 32px;
  box-sizing: border-box;
  background: #030712;
  color: white;
}
.context-header, .context-status, .context-message, .context-workspace {
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
}
.context-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 18px;
}
.context-header h1 { margin: 0 0 8px; }
.context-header p { margin: 0; color: #94a3b8; }
.context-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.context-actions button, .context-assistant-button {
  padding: 11px 16px;
  border: 1px solid rgba(255,255,255,0.16);
  border-radius: 10px;
  background: rgba(255,255,255,0.07);
  color: white;
  cursor: pointer;
  font-weight: 700;
}
.context-actions button.primary, .context-assistant-button { background: #4f46e5; border-color: #4f46e5; }
.context-actions button:disabled, .context-assistant-button:disabled { opacity: 0.45; cursor: default; }
.context-status {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 12px;
  border: 1px solid rgba(74,222,128,0.25);
  border-radius: 10px;
  background: rgba(34,197,94,0.08);
  color: #bbf7d0;
}
.context-status.unsaved { border-color: rgba(251,191,36,0.35); background: rgba(245,158,11,0.1); color: #fde68a; }
.context-message {
  padding: 12px 16px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: rgba(79,70,229,0.15);
  color: #cbd5e1;
}
.context-workspace {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
  gap: 18px;
  min-height: 680px;
  align-items: start;
}
.context-editor-panel, .context-assistant-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 18px;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  background: #0f172a;
}
.context-editor-panel { min-height: 680px; }
.context-assistant-panel {
  position: sticky;
  top: 20px;
  height: calc(100vh - 112px);
  max-height: 820px;
  box-sizing: border-box;
}
.context-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.context-panel-title h2 { margin: 0; font-size: 18px; }
.context-panel-title span { color: #94a3b8; font-size: 13px; }
.context-format-toolbar {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px;
  border: 1px solid rgba(255,255,255,0.12);
  border-bottom: 0;
  border-radius: 12px 12px 0 0;
  background: #e2e8f0;
}
.context-format-toolbar button, .context-format-toolbar select {
  min-height: 34px;
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: white;
  color: #0f172a;
  cursor: pointer;
}
.context-format-toolbar button { min-width: 36px; font-size: 15px; }
.context-rich-editor {
  flex: 1 1;
  min-height: 600px;
  padding: 18px;
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 0 0 12px 12px;
  background: #f8fafc;
  color: #0f172a;
  font: 16px/1.65 Arial, sans-serif;
  overflow: auto;
  outline: none;
  direction: ltr;
  text-align: left;
  unicode-bidi: plaintext;
}
.context-rich-editor:empty::before {
  content: attr(data-placeholder);
  color: #94a3b8;
  pointer-events: none;
}
.context-rich-editor p:first-child { margin-top: 0; }
.context-rich-editor p:last-child { margin-bottom: 0; }
.context-chat {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 4px 4px 12px;
}
.context-chat-empty { color: #94a3b8; line-height: 1.5; }
.context-chat-message {
  margin-bottom: 12px;
  padding: 11px 13px;
  border-radius: 10px;
  line-height: 1.45;
  white-space: pre-wrap;
}
.context-chat-message.user { margin-left: 22px; background: #4f46e5; }
.context-chat-message.assistant { margin-right: 22px; background: rgba(255,255,255,0.08); }
.context-assistant-input {
  width: 100%;
  box-sizing: border-box;
  min-height: 100px;
  margin: 0 0 10px;
  padding: 12px;
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 10px;
  background: rgba(255,255,255,0.06);
  color: white;
  resize: vertical;
}
.context-assistant-composer {
  flex: none;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.1);
  background: #0f172a;
}
.context-assistant-button { width: 100%; }
@media (max-width: 1000px) {
  .context-header { flex-direction: column; }
  .context-workspace { grid-template-columns: 1fr; }
  .context-assistant-panel { position: static; height: 620px; max-height: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContextPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA,qBAAqB,eAAe,EAAE;AACtC,oBAAoB,SAAS,EAAE,cAAc,EAAE;AAC/C,mBAAmB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC9D;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA,6DAA6D,mBAAmB,EAAE,qBAAqB,EAAE;AACzG,uEAAuE,aAAa,EAAE,eAAe,EAAE;AACvG;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA,0BAA0B,mCAAmC,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACjH;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,wBAAwB,iBAAiB,EAAE;AAC3C;EACE,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA,0BAA0B,SAAS,EAAE,eAAe,EAAE;AACtD,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA,iCAAiC,eAAe,EAAE,eAAe,EAAE;AACnE;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,wCAAwC;EACxC,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;AACA,qCAAqC,aAAa,EAAE;AACpD,oCAAoC,gBAAgB,EAAE;AACtD;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;AACA,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;AACA,6BAA6B,iBAAiB,EAAE,mBAAmB,EAAE;AACrE,kCAAkC,kBAAkB,EAAE,kCAAkC,EAAE;AAC1F;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA,4BAA4B,WAAW,EAAE;AACzC;EACE,kBAAkB,sBAAsB,EAAE;EAC1C,qBAAqB,0BAA0B,EAAE;EACjD,2BAA2B,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAChF","sourcesContent":[".context-page {\n  min-height: 100%;\n  padding: 32px;\n  box-sizing: border-box;\n  background: #030712;\n  color: white;\n}\n.context-header, .context-status, .context-message, .context-workspace {\n  max-width: 1500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.context-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  margin-bottom: 18px;\n}\n.context-header h1 { margin: 0 0 8px; }\n.context-header p { margin: 0; color: #94a3b8; }\n.context-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n.context-actions button, .context-assistant-button {\n  padding: 11px 16px;\n  border: 1px solid rgba(255,255,255,0.16);\n  border-radius: 10px;\n  background: rgba(255,255,255,0.07);\n  color: white;\n  cursor: pointer;\n  font-weight: 700;\n}\n.context-actions button.primary, .context-assistant-button { background: #4f46e5; border-color: #4f46e5; }\n.context-actions button:disabled, .context-assistant-button:disabled { opacity: 0.45; cursor: default; }\n.context-status {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  border: 1px solid rgba(74,222,128,0.25);\n  border-radius: 10px;\n  background: rgba(34,197,94,0.08);\n  color: #bbf7d0;\n}\n.context-status.unsaved { border-color: rgba(251,191,36,0.35); background: rgba(245,158,11,0.1); color: #fde68a; }\n.context-message {\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  border-radius: 10px;\n  background: rgba(79,70,229,0.15);\n  color: #cbd5e1;\n}\n.context-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);\n  gap: 18px;\n  min-height: 680px;\n  align-items: start;\n}\n.context-editor-panel, .context-assistant-panel {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: 18px;\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 16px;\n  background: #0f172a;\n}\n.context-editor-panel { min-height: 680px; }\n.context-assistant-panel {\n  position: sticky;\n  top: 20px;\n  height: calc(100vh - 112px);\n  max-height: 820px;\n  box-sizing: border-box;\n}\n.context-panel-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n.context-panel-title h2 { margin: 0; font-size: 18px; }\n.context-panel-title span { color: #94a3b8; font-size: 13px; }\n.context-format-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px;\n  border: 1px solid rgba(255,255,255,0.12);\n  border-bottom: 0;\n  border-radius: 12px 12px 0 0;\n  background: #e2e8f0;\n}\n.context-format-toolbar button, .context-format-toolbar select {\n  min-height: 34px;\n  padding: 6px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: white;\n  color: #0f172a;\n  cursor: pointer;\n}\n.context-format-toolbar button { min-width: 36px; font-size: 15px; }\n.context-rich-editor {\n  flex: 1;\n  min-height: 600px;\n  padding: 18px;\n  border: 1px solid rgba(255,255,255,0.12);\n  border-radius: 0 0 12px 12px;\n  background: #f8fafc;\n  color: #0f172a;\n  font: 16px/1.65 Arial, sans-serif;\n  overflow: auto;\n  outline: none;\n  direction: ltr;\n  text-align: left;\n  unicode-bidi: plaintext;\n}\n.context-rich-editor:empty::before {\n  content: attr(data-placeholder);\n  color: #94a3b8;\n  pointer-events: none;\n}\n.context-rich-editor p:first-child { margin-top: 0; }\n.context-rich-editor p:last-child { margin-bottom: 0; }\n.context-chat {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 4px 4px 12px;\n}\n.context-chat-empty { color: #94a3b8; line-height: 1.5; }\n.context-chat-message {\n  margin-bottom: 12px;\n  padding: 11px 13px;\n  border-radius: 10px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n.context-chat-message.user { margin-left: 22px; background: #4f46e5; }\n.context-chat-message.assistant { margin-right: 22px; background: rgba(255,255,255,0.08); }\n.context-assistant-input {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 100px;\n  margin: 0 0 10px;\n  padding: 12px;\n  border: 1px solid rgba(255,255,255,0.14);\n  border-radius: 10px;\n  background: rgba(255,255,255,0.06);\n  color: white;\n  resize: vertical;\n}\n.context-assistant-composer {\n  flex: none;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255,255,255,0.1);\n  background: #0f172a;\n}\n.context-assistant-button { width: 100%; }\n@media (max-width: 1000px) {\n  .context-header { flex-direction: column; }\n  .context-workspace { grid-template-columns: 1fr; }\n  .context-assistant-panel { position: static; height: 620px; max-height: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
